import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STEPS = [
  "Discover Crowned",
  "Need help choosing? — Client Intake",
  "Choose Your Experience",
  "Make Your Initial Payment",
  "Tell Us Your Story — Creative Questionnaire",
  "Photograph / Photo / Creative Direction",
  "We Create",
  "Review Your Masterpiece",
  "Final Approval",
  "Complete Remaining Payment",
  "Production",
  "Delivery",
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative z-10 border-t border-white/5 py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-14">
          <div className="md:col-span-6">
            <p className="overline">How It Works</p>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-4 leading-tight">
              Twelve steps from<br /> story to <span className="italic text-[#D4AF37]">statement piece.</span>
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-white/60 font-light leading-relaxed self-end">
            Every Crowned experience follows the same measured process — from
            your first payment to the moment your masterpiece arrives. Nothing
            rushed. Nothing generic.
          </p>
        </div>

        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
          {STEPS.map((s, i) => (
            <li
              key={s}
              data-testid={`process-step-${String(i + 1).padStart(2, "0")}`}
              className="group bg-[#080808] p-6 md:p-7 hover:bg-[#824937]/15 transition-colors"
            >
              <span className="font-serif-display text-3xl text-[#D4AF37]/70 group-hover:text-[#D4AF37] transition-colors">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-serif-display text-base md:text-lg leading-snug mt-4 text-[#F7F1E7]">
                {s}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-10 text-center">
          <Link
            to="/how-it-works"
            data-testid="process-more-link"
            className="group inline-flex items-center gap-3 border border-[#824937] bg-[#824937]/20 text-[#F7F1E7] px-7 py-4 text-xs uppercase tracking-[0.22em] hover:bg-[#824937]/40 transition-all"
          >
            See The Full Crowned Process
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}
